import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Why from "@/components/site/Why";
import Rooms from "@/components/site/Rooms";
import Escape from "@/components/site/Escape";
import Amenities from "@/components/site/Amenities";
import Gallery from "@/components/site/Gallery";
import Location from "@/components/site/Location";
import Booking from "@/components/site/Booking";
import Footer from "@/components/site/Footer";
import useReveal from "@/lib/useReveal";

export default function Landing() {
  useReveal();
  return (
    <main data-testid="landing-root" className="relative">
      <Nav />
      <Hero />
      <Why />
      <Rooms />
      <Escape />
      <Amenities />
      <Gallery />
      <Location />
      <Booking />
      <Footer />
    </main>
  );
}
